'use client'

import { useTranslations } from 'next-intl'
import { PropsWithChildren } from 'react'

import { AuthBrand, AuthFormLayout, AuthPanel } from '@/styled/auth'
import { BrandMark } from '@/styled/layout'
import { Card, Flex, Heading, Text } from '@radix-ui/themes'

type TProps = PropsWithChildren<{
    title: string
    subtitle?: string
}>

/** App brand + a card for the pages without the app layout (login, setting a password). */
const AuthCard = ({ title, subtitle, children }: TProps) => {
    const t = useTranslations('app')

    return (
        <AuthPanel>
            <AuthBrand>
                <BrandMark $size="2.75rem">IS</BrandMark>
                <Heading size="5" weight="bold">
                    {t('title')}
                </Heading>
            </AuthBrand>
            <Card size={{ initial: '3', xs: '4' }}>
                <Flex direction="column" gap="5">
                    <Flex direction="column" gap="1">
                        <Heading size="6">{title}</Heading>
                        {subtitle && (
                            <Text size="2" color="gray">
                                {subtitle}
                            </Text>
                        )}
                    </Flex>
                    <AuthFormLayout>{children}</AuthFormLayout>
                </Flex>
            </Card>
        </AuthPanel>
    )
}

export default AuthCard
